// extracted by mini-css-extract-plugin
export default {"container":"BJ-z","error":"CJ-z","disabled":"DJ-z","submit":"EJ-z","option":"FJ-z","success":"GJ-z","failure":"HJ-z"};